// extracted by mini-css-extract-plugin
export default {"profileContainer":"Profile_profileContainer__xJvWM","supportBtn":"Profile_supportBtn__vKdb0","buttonsContainer":"Profile_buttonsContainer__GpLxy","btn":"Profile_btn__cA2TR"};